import { Box, Button, Typography } from '@mui/material';
import { isIframe, sendDataToIframe, getManagerSearchParams, useNavigateWithQueryParams, useWindowDimensions, isMobileApp, sendDataToMobileApp } from '../Utilities';
import { useTranslation } from 'react-i18next';
import { useKeycloak } from '../Keycloak';
import { ArrowBackIos, Login, Logout, OpenInNew } from '@mui/icons-material';

export default function Status({ code, controls, href }) {

    const { contentHeight, windowHeight } = useWindowDimensions()
    const { HOME } = window.conf.ROUTES
    const { t } = useTranslation()
    const { doLogout, doLogin } = useKeycloak()
    const { isSingleProject, isManager } = getManagerSearchParams()
    
    const navigate = useNavigateWithQueryParams()
    const hasControl = (control) => controls?.includes(control)
    const disableCredentialControl = 
        (isManager && !isSingleProject) || // if accessed via manager and it is not a single project OR
        (isIframe && !isManager) // if it is an iframe and not accessed via manager (if customer uses iframe to show single portal)
    const hasBackInitial = (!isManager || isSingleProject) && isMobileApp

    const handleBack = () => {
        if (window.history.length > 2) { // try to skip same page or keycloak login
            navigate(-1)
        // } else if (window.history.length === 1 && hasBackInitial) {
        } else if (hasBackInitial) { // because window.history.length is 2 if its a single portal from app!
            sendDataToMobileApp({ type: "logout" })
        } else {
            navigate(HOME.path, { replace: true })
        }
    }

    const handleLogout = () => {
        if (isManager && isSingleProject) {
            sendDataToIframe({ type: "goHomeAndLogout" })
        } else {
            doLogout()
        }
        
        isMobileApp && sendDataToMobileApp({ type: "logout" })
    }

    const handleLogin = () => {
        // // if home is protected, redirect to MYSITE after login - leads to confusing behavior when mysite is protected
        // const isHome = hasControl("login") && !hasControl("header")
        // doLogin(isHome ? { redirectUri: window.location.origin + MYSITE.path } : {})
        doLogin()
    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: hasControl("header") ? contentHeight : windowHeight
            }}
        >

            <Typography 
                variant="h1" 
                sx={{ 
                    color: 'white',
                    userSelect: 'none'
                }}
            >
                {t("status.sorry")}
            </Typography>

            <Typography 
                variant="h6" 
                sx={{ 
                    color: 'white', 
                    maxWidth: '80%', 
                    textAlign: 'center',
                    userSelect: 'none'
                }}
            >
                {t("status." + code)}
            </Typography>

            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 2,
                marginTop: '20px'
            }}>

                {hasControl("back") && (
                    <Button 
                        variant="contained" 
                        onClick={handleBack}
                        size="large"
                        startIcon={<ArrowBackIos />}
                    >
                        {t("status.back_home")}
                    </Button>
                )}

                {hasControl("logout") && !disableCredentialControl && (
                    <Button
                        variant="contained"
                        onClick={handleLogout}
                        size="large"
                        startIcon={<Logout />}
                    >
                        {t("user.logout")}
                    </Button>
                )}

                {hasControl("login") && !disableCredentialControl && (
                    <Button 
                        variant="contained" 
                        onClick={handleLogin}
                        size="large"
                        endIcon={<Login />}
                    >
                        {t("user.login")}
                    </Button>
                )}

                {hasControl("link") && href && (
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<OpenInNew />}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("status.open_directly")}
                    </Button>
                )}

            </Box>

        </Box>
    )
}